import { useContext } from 'react';
import newOrderContext, { ProviderContext } from './newOrderContext';

const useNewOrder = (): ProviderContext => useContext(newOrderContext)
export default useNewOrder;